import { ModelNames } from "../models";
import notificationFilters from "./notifications";
import partnersFilters from "./partners";
import taskFilters from "./tasks";

export const modelFilters = {
  // [ModelNames.SIMULATIONS]: simulationFilters,
  // [ModelNames.QUOTATIONS]: quotationFilters,
  // [ModelNames.PROPOSALS]: proposalFilters,
  // [ModelNames.INSURANCES]: insuranceFilters,
  [ModelNames.PARTNERS]: partnersFilters,
  [ModelNames.NOTIFICATIONS]: notificationFilters,
  [ModelNames.TASKS]: taskFilters,
};
